import * as React from 'react'

import Svg, { G, Mask, Path } from 'react-native-svg'

import { IconProps } from '..'

const FAQ = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Mask
      id="a"
      width={size}
      height={size}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <Path fill="#D9D9D9" d="M0 0h24v24H0z" />
    </Mask>
    <G mask="url(#a)">
      <Path
        fill="#6826A0"
        d="m12 23-3-3H5c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 18V4c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 5 2h14c.55 0 1.02.196 1.413.587C20.803 2.98 21 3.45 21 4v14c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 19 20h-4l-3 3Zm-7-5h4.8l2.2 2.2 2.2-2.2H19V4H5v14Zm6.95-1.2c.35 0 .646-.12.888-.363.241-.241.362-.537.362-.887s-.12-.646-.362-.888a1.207 1.207 0 0 0-.888-.362c-.35 0-.646.12-.887.362a1.207 1.207 0 0 0-.363.888c0 .35.12.646.363.887.241.242.537.363.887.363Zm.95-3.85c0-.6.067-1.042.2-1.325.133-.283.417-.642.85-1.075.583-.583.996-1.07 1.238-1.463.241-.391.362-.837.362-1.337 0-.883-.3-1.596-.9-2.138-.6-.541-1.408-.812-2.425-.812-.917 0-1.696.225-2.338.675C9.246 5.925 8.8 6.55 8.55 7.35L10.2 8c.117-.45.35-.813.7-1.088.35-.274.758-.412 1.225-.412.45 0 .825.12 1.125.362.3.242.45.563.45.963 0 .283-.092.583-.275.9-.183.317-.492.667-.925 1.05-.55.483-.93.946-1.137 1.387-.209.442-.313 1.038-.313 1.788h1.85Z"
      />
    </G>
  </Svg>
)
export default FAQ
